import { ReservationType } from "@/app/lib/types/enums";

export const reservationTypesLabels = {
  [ReservationType.PAST]: "bookings.past",
  [ReservationType.UPCOMING]: "bookings.upcoming",
  [ReservationType.REFUNDED]: "bookings.cancelled",
};
